import { useSyncExternalStore } from 'react';

const subscribe = (callback: () => void) => {
  const mediaQuery = window.matchMedia('(max-width: 767px)');
  mediaQuery.addEventListener('change', callback);
  return () => mediaQuery.removeEventListener('change', callback);
};

const getSnapshot = () => {
  return window.matchMedia('(max-width: 767px)').matches;
};

const getServerSnapshot = () => {
  return false;
};

export function useIsMobile() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
